module.exports = __webpack_public_path__ + "static/media/checkmark-grey.1f7f551c.svg";